module.exports = __webpack_public_path__ + "static/c4-5720eee92ffdefbb9528c2da606697cf.png";